import React from "react";
import { FaTrophy, FaGift } from "react-icons/fa";

export const OrderPrizeBadge = ({ order }) => {
  // Check if order has won any prize
  const hasPrizes =
    Boolean(order?.isWon) ||
    Boolean(order?.prizeAmount && Number(order.prizeAmount) > 0) ||
    Boolean(order?.prizes && Object.keys(order.prizes).length > 0) ||
    Boolean(order?.lotteries?.some((l) => l.isWon || l.prize || l.prizes?.length > 0));

  if (!hasPrizes) return null;

  const totalPrizeAmount =
    order?.prizeAmount ||
    order?.lotteries?.reduce((acc, l) => acc + (Number(l.prizeAmount) || 0), 0) ||
    0;

  return (
    <div className="bg-gradient-to-r from-amber-500/15 via-yellow-500/10 to-amber-500/15 border border-amber-300 rounded-md p-3.5 mb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 shadow-xs">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-amber-500 text-white flex items-center justify-center text-lg shadow-sm">
          <FaTrophy />
        </div>
        <div>
          <h4 className="font-bold text-sm text-amber-950 flex items-center gap-1.5">
            <span>🎉 คำสั่งซื้อนี้ถูกรางวัลสลากกินแบ่งรัฐบาล!</span>
          </h4>
          <p className="text-xs text-amber-800 font-medium mt-0.5">
            กรุณาตรวจสอบบัญชีรับเงินรางวัลของลูกค้าเพื่อดำเนินการโอนเงินรางวัล
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 bg-white px-3.5 py-2 rounded-md border border-amber-300 shadow-xs self-stretch md:self-auto justify-between md:justify-end">
        <span className="text-xs font-semibold text-slate-500 flex items-center gap-1">
          <FaGift className="text-amber-500" /> เงินรางวัลรวม:
        </span>
        <span className="font-bold text-base text-amber-600">
          {Number(totalPrizeAmount).toLocaleString()} บาท
        </span>
      </div>
    </div>
  );
};
